import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { columns, tickerList } from "@/mocks/news";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const navMain = [
    { to: "/", label: "首页" },
    ...columns.map((c) => ({ to: `/column/${c.slug}`, label: c.name })),
    { to: "/about", label: "关于我们" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 今日瓜条 */}
      <div className="flex items-center gap-3 bg-foreground-950 px-4 py-1.5 text-background-50 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-bold">
          <i className="ri-fire-fill text-sm"></i>
          今日瓜条
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-ticker flex w-max items-center gap-10 whitespace-nowrap text-xs text-background-200 md:text-sm">
            {tickerList.map((t, i) => (
              <span key={i} className="flex items-center gap-2">
                <span className="text-accent-400">●</span>
                {t}
              </span>
            ))}
            {tickerList.map((t, i) => (
              <span key={`d-${i}`} className="flex items-center gap-2">
                <span className="text-accent-400">●</span>
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div
        className={`w-full transition-colors ${
          scrolled ? "bg-background-50/95 backdrop-blur" : "bg-background-50"
        }`}
      >
        <div className="flex items-center justify-between gap-4 px-4 py-3 md:px-6">
          <Link
            to="/"
            className="group flex items-center gap-2 whitespace-nowrap"
            aria-label="98爆料首页"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50">
              <i className="ri-megaphone-fill"></i>
            </span>
            <span className="leading-none">
              <span className="block font-heading text-2xl font-black tracking-tight text-foreground-950">
                98<span className="text-primary-500">爆料</span>
              </span>
              <span className="mt-0.5 block text-[10px] tracking-[0.2em] text-foreground-500">
                娱乐八卦 · 每天在线吃瓜
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navMain.map((item) => {
              const active =
                item.to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    active
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-secondary-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <Link
              to="/about"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-secondary-600"
            >
              <i className="ri-quill-pen-fill text-base"></i>
              投稿爆料
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg text-xl text-foreground-800 hover:bg-secondary-100 md:hidden"
            aria-label="切换导航菜单"
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>

        {open && (
          <nav
            className="flex flex-col gap-1 border-t border-background-200 px-4 pb-4 pt-3 md:hidden"
            aria-label="移动端导航"
          >
            {navMain.map((item) => {
              const active =
                item.to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`rounded-lg px-4 py-2.5 text-sm font-medium ${
                    active
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-secondary-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        )}
      </div>
    </header>
  );
}